var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeenyiconsPrintOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_6051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5998 20H2.3998C1.97546 20 1.56849 19.8314 1.26843 19.5314C0.968376 19.2313 0.799805 18.8243 0.799805 18.4V12C0.799805 11.5757 0.968376 11.1687 1.26843 10.8686C1.56849 10.5686 1.97546 10.4 2.3998 10.4H21.5998C22.0242 10.4 22.4311 10.5686 22.7312 10.8686C23.0312 11.1687 23.1998 11.5757 23.1998 12V18.4C23.1998 18.8243 23.0312 19.2313 22.7312 19.5314C22.4311 19.8314 22.0242 20 21.5998 20H18.3998M5.5998 10.4V2.4C5.5998 1.97566 5.76838 1.56869 6.06843 1.26863C6.36849 0.968574 6.77546 0.800003 7.1998 0.800003H16.7998C17.2242 0.800003 17.6311 0.968574 17.9312 1.26863C18.2312 1.56869 18.3998 1.97566 18.3998 2.4V10.4M5.5998 16.8H18.3998V23.2H5.5998V16.8Z",
    stroke: "#ED583B",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_6051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsPrintOutline);
export default __webpack_public_path__ + "static/media/teenyicons_print-outline.27b8988177229309dea0b8950542a36d.svg";
export { ForwardRef as ReactComponent };